import React from 'react';
import {Box, Typography} from '@mui/material';

interface LabeledFieldProps {
  label: string;
  value?: string;
  direction?: 'row' | 'column';
  variant?: 'body1' | 'body2';
  bold?: boolean;
  children?: React.ReactNode;
  sx?: object;
}

export const LabeledField = ({
  label,
  value,
  direction = 'column',
  variant = 'body1',
  bold = true,
  children,
  sx
}: LabeledFieldProps) => {
  return (
    <Box sx={{display: 'flex', flexDirection: direction, justifyContent: 'space-between', ...sx}}>
      <Typography variant={'body2'} color={'text.secondary'}>
        {label}
      </Typography>
      {children ?? (
        <Typography variant={variant || 'body1'} fontFamily={bold ? 'OpenSansMedium' : 'OpenSansRegular'}>
          {value}
        </Typography>
      )}
    </Box>
  );
};
